import { render, staticRenderFns } from "./ProductInfoForm.vue?vue&type=template&id=2345fac7&scoped=true&"
import script from "./ProductInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProductInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoForm.vue?vue&type=style&index=0&id=2345fac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345fac7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCheckbox,VCol,VRow,VSpacer})
